<template>
  <v-sheet class="kim-card" >
    <v-layout wrap align-center>
      <v-flex xs6 pa-2 text-xs-left>
        <v-img class="mr-auto" :src="require('@/assets/logo.png')" width="100" />
      </v-flex>
      <v-flex xs6 pr-3 text-xs-right>
        <v-btn @click="logout" depressed outline color="accent" small round>
          <v-icon size="14" class="mr-1">fa-sign-out-alt</v-icon>
          salir
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs12 lg8 offset-lg2 pt-4>
        <v-carousel style="height: 700px" light v-model="model" :cycle="false" class="elevation-0" hide-controls hide-delimiters>

          <v-carousel-item style="height: 700px" >
              <v-card color="transparent" flat>

                <v-card-title>
                  <h1 class="headline font-weight-light black--text mx-auto">¡Bienvenid@!</h1>
                </v-card-title>
                <v-card-title class="py-0">
                  <p class="body-1 black--text mx-auto">Vamos a configurar tu cuenta, sólo tomará unos minutos...</p>
                </v-card-title>

                <v-card-text>
                  <v-layout align-center justify-center>
                    <v-flex xs12 text-xs-center>
                      <v-scale-transition>
                        <v-img
                            v-show="showIntroImage"
                            class="mx-auto"
                            max-width="230"
                            :src="require('@/assets/img/become-provider.jpg')"/>
                      </v-scale-transition>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions class="pa-3">
                  <v-btn @click="model=1" depressed round color="primary" v-show="showIntroButton" class="mx-auto">
                    Continuar
                    <v-icon right size="16">fas fa-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>

              </v-card>
          </v-carousel-item>

          <v-carousel-item style="height: 700px" >

            <v-sheet color="white" height="100%" tile>
              <v-card color="white" flat>

                <v-card-text class="py-1">
                  <v-form >
                    <v-layout wrap align-center justify-center>
                      <v-flex xs12 md8>

                        <div class="title">Tu Negocio</div>
                        <small class="body-1">Si sólo necesitas <b>{{ appName }}</b> para uso personal, selecciona <b>Consulta Particular</b>...</small>

                        <institution-type-picker
                            class="mt-3"
                            style="z-index:1000"
                            required
                            v-on:change="onTypeSelect"
                            :includeIndividualAccountType="true"
                        />
                        <v-text-field
                            required
                            outline
                            v-if="showName"
                            v-model="name"
                            label="Nombre del negocio"
                            placeholder="Ej. Super Centro"></v-text-field>
                        <v-textarea
                            outline
                            dense
                            height="90"
                            v-model="description"
                            label="Descripción"
                            maxlength="150"
                            counter="150"
                            placeholder="Ej. Siempre a la vanguardia en tecnología, somos lo mejor de la zona..."
                        ></v-textarea>

                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>

                <v-card-actions class="py-0">
                  <div class="mx-auto">
                    <v-btn fab small depressed @click="model=0" color="secondary">
                      <v-icon>fas fa-arrow-left</v-icon>
                    </v-btn>
                    <v-btn :disabled="done || !step2Valid" @click="setAccountType" depressed round color="primary">
                      Continuar
                      <v-icon right size="16">fas fa-arrow-right</v-icon>
                    </v-btn>
                  </div>

                </v-card-actions>

              </v-card>
            </v-sheet>
          </v-carousel-item>

          <v-carousel-item style="height: 700px" >

            <v-sheet color="white" height="100%" tile>
              <v-card color="white" flat>

                <v-card-text class="py-1">
                  <v-flex xs12 md8 offset-md2>

                    <div class="title">Sucursal</div>
                    <small class="body-1">Si tu negocio tiene mas de una sucursal, ingresa los datos de la sucursal principal.</small>

                    <branch-office-form class="mt-3" strict-mode @change="branchOffice = $event" @change:validation="step3Valid = true" />
<!--                    <branch-office-form class="mt-3" strict-mode @change="branchOffice = $event" @change:validation="step3Valid = $event" />-->

                  </v-flex>

                </v-card-text>

                <v-card-actions class="py-0">
                  <div class="mx-auto">
                    <v-btn fab small depressed @click="backToAccountTypeSelection" color="secondary">
                      <v-icon>fas fa-arrow-left</v-icon>
                    </v-btn>
                    <v-btn :disabled="done || !step3Valid" @click="setBranchOffice" depressed round color="primary">
                      Continuar
                      <v-icon right size="16">fas fa-arrow-right</v-icon>
                    </v-btn>
                  </div>

                </v-card-actions>

              </v-card>
            </v-sheet>

          </v-carousel-item>

          <v-carousel-item style="height: 700px" >

            <v-sheet color="white" height="100%" tile>
              <v-card color="white" flat>

                <v-card-text class="py-1">
                  <v-flex xs12 md8 offset-md2>

                    <div class="title">Servicios</div>

                    <small class="body-1 mt-2">Selecciona los servicios / especialidades que ofreces, este paso es importante para que <b>{{ appName }}</b> pueda ofrecer el set de herramientas adecuado...</small>

                    <v-card color="grey lighten-4" flat class="pa-4 my-3">
                      <v-card-text class="text-xs-center">
                        <service-picker
                            label="Seleccionar Servicios"
                            type="specialty"
                            multiple
                            @change="services = $event"
                        />
                      </v-card-text>
                    </v-card>

                  </v-flex>

                </v-card-text>

                <v-card-actions class="py-0">
                  <div class="mx-auto">
                    <v-btn fab small depressed @click="backFromServices" color="secondary">
                      <v-icon>fas fa-arrow-left</v-icon>
                    </v-btn>
                    <v-btn :disabled="done || !step4Valid" @click="model++" depressed round color="primary">
                      Continuar
                      <v-icon right size="16">fas fa-arrow-right</v-icon>
                    </v-btn>
                  </div>

                </v-card-actions>

              </v-card>
            </v-sheet>

          </v-carousel-item>

          <v-carousel-item style="height: 700px" >

            <v-sheet color="white" height="100%" tile>
              <v-card color="white" flat>

                <v-card-text class="py-1">
                  <v-flex xs12 md8 offset-md2>

                    <div class="title">Logo <small class="caption">(Opcional)</small></div>

                    <small class="body-1 mt-2">Dale una imagen mas profesional a tu perfil, carga tu logo...</small>

                      <v-card color="grey lighten-4" flat class="pa-4 my-3">
                        <v-card-text class="text-xs-center">
                          <image-picker @change:validation="avatarValid = $event" max-size="2" @change="logo = $event" />
                        </v-card-text>
                      </v-card>

                  </v-flex>

                </v-card-text>

                <v-card-actions class="py-0">
                  <div class="mx-auto">
                    <v-btn v-if="!done" :disabled="loading" fab small depressed @click="model--" color="secondary">
                      <v-icon>fas fa-arrow-left</v-icon>
                    </v-btn>
                    <v-btn :disabled="done ||!avatarValid " @click="save" :loading="loading" depressed round color="primary">
                      Finalizar
                      <v-icon right size="16">fas fa-arrow-right</v-icon>
                    </v-btn>
                  </div>

                </v-card-actions>

              </v-card>
            </v-sheet>

          </v-carousel-item>

          <v-carousel-item :disabled="true" :value="5">

            <v-sheet color="white" height="100%" tile>
              <v-card color="white" flat>

                <v-card-title>
                  <h1 class="headline font-weight-light black--text mx-auto">...Listo!</h1>
                </v-card-title>

                <v-card-title class="py-0">
                  <p class="caption black--text mx-auto">¡Hemos terminado de configurar tu cuenta!</p>
                </v-card-title>

                <v-card-text>
                  <v-layout align-center justify-center>
                    <v-flex xs12 text-xs-center>
                      <v-scale-transition>
                        <v-img v-show="showOutroImage" class="mx-auto" max-width="250"
                               :src="require('@/assets/img/outro_img.png')"/>
                      </v-scale-transition>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions class="pa-2 text-xs-center">
                  <v-btn color="primary" class="mx-auto" round :to="{name: 'panel.dashboard'}">Comenzar a utilizar {{ appName }}</v-btn>
                </v-card-actions>

              </v-card>
            </v-sheet>

          </v-carousel-item>

        </v-carousel>
      </v-flex>
    </v-layout>
  </v-sheet>
</template>

<script>

import InstitutionTypePicker from '@/components/providers/InstitutionTypePicker'

import {ApiUtils} from '@/utils/ApiUtils'
import {mapMutations} from 'vuex'
import BranchOfficeForm from "../../components/providers/panel/BranchOfficeForm";
import ImagePicker from "@/components/common/ImagePicker";
import ServicePicker from "@/components/providers/ServicePicker";

export default {
  components: {
    ServicePicker,
    ImagePicker,
    BranchOfficeForm,
    InstitutionTypePicker
  },
  data() {
    return {
      dialog: false,
      model: 0,
      services: [],
      showOutroImage: false,
      showOutroButton: false,
      showIntroImage: false,
      showIntroButton: false,
      avatarValid: true,
      loading: false,
      name: '',
      description: '',
      logo: null,
      branchOffice: null,
      type: {
        id: 'individual',
        name: 'Consulta Particular'
      },
      done: false,
      step3Valid: true,
      // step3Valid: false,
    }
  },
  mounted() {
    const vm = this
    vm.showIntro()
  },
  methods: {
    ...mapMutations(['showSnackBar']),
    backFromServices(){
      const vm = this
      if(vm.type.id === 'individual'){
        vm.model = 1
      }else{
        vm.model = 2
      }
    },
    async logout() {
      await ApiUtils.logout()
    },
    setAccountType(){
      const vm = this
      if(vm.type.id !== 'individual'){
        vm.model = 2
      }else{
        vm.model = 3
      }
    },
    setBranchOffice(){
      const vm = this
      vm.model = 3
    },
    backToAccountTypeSelection(){
      const vm = this
      vm.model = 1
    },
    showIntro() {
      var vm = this

      vm.model = 0
      setTimeout(function () {
        vm.showIntroImage = true
      }, 300)
      setTimeout(function () {
        vm.showIntroButton = true
      }, 500)

    },
    onTypeSelect(type) {
      this.type = type
    },
    show() {
      this.dialog = true
    },
    hide() {
      this.dialog = false
    },
    async save() {

      var vm = this
      if (vm.loading) return

      if ((vm.type.id !== 'individual' && !vm.name) || !vm.description) {
        vm.showSnackBar('Todos los campos son obligatorios.')
        return
      }

      vm.loading = true
      const response = await ApiUtils.makePost('provider', {
        description: vm.description,
        avatar: vm.logo,
        services: vm.services.map(serv => serv.id),
        institution: vm.type.id === 'individual' ? null :
            {
              name: vm.name,
              institution_type_id: vm.type.id,
              branch_offices: [{
                ...vm.branchOffice,
                main: 1
              }]
            }
      })
      vm.loading = false

      if (!response.ok) {
        const json = await response.json()
        vm.showSnackBar(json.message || 'Ha ocurrido un error intentando crear proveedor')
        return
      }

      vm.showSnackBar('Felicidades, ya eres proveedor!')
      vm.model = 5
      vm.done = true

      setTimeout(function(){
        vm.showOutroImage = true
      }, 500)

      await ApiUtils.fetchMe()

    }
  },
  computed: {
    step2Valid(){
      const vm = this
      if(vm.type.id !== 'individual' && !vm.name){
        return false
      }

      if(!vm.description) return false

      return true

    },
    step4Valid(){
      const vm = this
      return vm.services.length > 0
    },
    showName() {
      var vm = this
      return vm.type && vm.type.id !== 'individual'
    }
  },
  watch: {
    model(val) {

    }
  }
}
</script>

<style scoped>
>>> .v-carousel__controls {
  background-color: rgba(0, 0, 0, 0);
}

>>> .v-item-group.theme--dark .theme--dark.v-btn {
  color: #020202;
}

</style>